export default {
   api_host: 'https://dev.srv-ziqlabs-1.my.id'
   // api_host: 'http://localhost:2036'
}